"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertSpeakingMode = exports.SpeakingMode = void 0;
const validate_1 = require("../utils/validate");
var SpeakingMode;
(function (SpeakingMode) {
    // These don't currently match because the naming changed, but changing these enums requires a database migration.
    // TODO: Make these enums match and migrate or nuke the `discussions` database collection.
    SpeakingMode["SEQUENCED"] = "STRUCTURED";
    SpeakingMode["NON_SEQUENCED"] = "UNSTRUCTURED";
})(SpeakingMode = exports.SpeakingMode || (exports.SpeakingMode = {}));
const speakingModes = Object.values(SpeakingMode);
function assertSpeakingMode(value, valueName) {
    if (!speakingModes.includes(value)) {
        throw validate_1.typeError('SpeakingMode', value, valueName);
    }
    return value;
}
exports.assertSpeakingMode = assertSpeakingMode;
//# sourceMappingURL=SpeakingMode.js.map